import { Check, ArrowRight } from "lucide-react";
import { INCLUDED } from "@/data/content";
import { Reveal, SectionHead } from "@/components/site/Reveal";
import { PlacesCounter } from "@/components/site/PlacesCounter";

export const Pricing = ({ camp, onRegister }) => (
  <section id="pricing" data-testid="pricing-section" className="section">
    <SectionHead eyebrow="Registration" testid="pricing-title" title={<>Secure your<br /><span className="accent-text">place</span></>} />
    <div className="grid lg:grid-cols-12 gap-6">
      <Reveal className="lg:col-span-7 relative overflow-hidden rounded-[2rem] border border-[var(--accent)]/30 bg-white/[0.03] p-8 md:p-12">
        <img src="/images/team.jpg" alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-10" />
        <div className="relative">
          <p className="eyebrow">Per player</p>
          <p className="mt-4 font-display font-extrabold tracking-tighter leading-none text-5xl sm:text-6xl md:text-7xl" data-testid="pricing-amount">$549<span className="block sm:inline mt-2 sm:mt-0 text-xl md:text-2xl text-slate-400 font-bold"> AUD</span></p>
          <p data-testid="pricing-fee-note" className="mt-2 text-sm text-slate-400">Including GST · <span className="text-slate-200">$549 total at checkout</span> per player · Stripe transaction fee already deducted</p>
          <p data-testid="pricing-promo-note" className="mt-1 text-sm text-slate-400">Have a promo code? Enter it on the secure payment page.</p>
          <p data-testid="pricing-per-day" className="mt-4 inline-flex items-center gap-2 rounded-full bg-[var(--accent)]/10 border border-[var(--accent)]/25 px-4 py-1.5 text-sm">
            <span className="accent-text font-semibold">Just $61 per day</span><span className="text-slate-400">over 9 days of elite coaching</span>
          </p>
          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {INCLUDED.map((i) => (
              <li key={i.t} className="flex gap-3 text-sm text-slate-200"><Check size={16} className="accent-text mt-0.5 shrink-0" />{i.t}</li>
            ))}
          </ul>
          <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-6">
            <button onClick={onRegister} className="btn-primary" data-testid="pricing-register-button">Secure Your Spot <ArrowRight size={18} /></button>
            <PlacesCounter camp={camp} />
          </div>
        </div>
      </Reveal>
      <Reveal className="lg:col-span-5 flex flex-col gap-6" delay={0.1}>
        <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-8" data-testid="pricing-deadline">
          <p className="text-[11px] font-mono-epl uppercase tracking-wider text-slate-500">Registration closes</p>
          <p className="mt-3 font-display text-3xl font-bold tracking-tight">25 November 2026</p>
          <p className="mt-2 text-sm text-slate-400">Or earlier if the programme reaches capacity. No waitlist.</p>
        </div>
        <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-8 flex-1" data-testid="pricing-refund-policy">
          <p className="text-[11px] font-mono-epl uppercase tracking-wider text-slate-500">Refund policy</p>
          <div className="mt-5 space-y-4">
            <div className="flex justify-between gap-4 border-b border-white/10 pb-4"><span className="text-sm text-slate-300">Before 25 November 2026</span><span className="font-mono-epl accent-text">50% refund</span></div>
            <div className="flex justify-between gap-4"><span className="text-sm text-slate-300">After 25 November 2026</span><span className="font-mono-epl text-slate-400">Non-refundable</span></div>
          </div>
          <p className="mt-6 text-xs text-slate-500">Summary only. Full terms are published on our Terms page.</p>
        </div>
      </Reveal>
    </div>
  </section>
);
